import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission && !_vm.locked)?_c('div',{staticClass:"addAddCardButtonContainer",on:{"click":function($event){return _vm.$emit('click')}}},[_c(VIcon,{attrs:{"size":"40"}},[_vm._v(" action_add_circle ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }